<template>
  <div class="footers">
    <!-- 保持footer-row控制整体垂直对齐 -->
    <el-row class="contain footer-row">
      <!-- 第一个el-col添加col-top class，实现靠上对齐 -->
      <el-col :span="6" class="col-top" style="text-align: left">
        <img src="https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/header/logo.png" class="logo"/>
      </el-col>
      <el-col :span="3" class="menu-col">
        <a @click="$router.push('/home')" class="link-tab short-menu">首&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;页</a>
        <a @click="$router.push('/company')" class="link-tab">企业介绍</a>
        <a @click="$router.push('/profession')" class="link-tab short-menu">专&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业</a>
        <a @click="$router.push('/solution')" class="link-tab">解决方案</a>
        <a @click="$router.push('/team')" class="link-tab">菁英团队</a>
        <a @click="$router.push('/about')" class="link-tab">联系我们</a>
      </el-col>
      <el-col :span="7" style="text-align: left">
        <img class='image2' src="https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/footer/wechat.png"/>
        <p class="introduce">客服热线：010-53359933</p>
        <p class="introduce">电子邮箱：zyt@sfdy.com</p>
        <p class="introduce">北京市昌平区七北路42号院3号楼7层3单元708</p>
      </el-col>
      <el-col :span="8">
        <el-row>
          <el-col :span="12">
            <img class='image0' src="https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/footer/car.png"/>
            <p class="code-title">车主端</p>
          </el-col>
          <el-col :span="12">
            <img class='image1' src="https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/footer/owner.png"/>
            <p class="code-title">货主端</p>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div class="icp-content">
      智运通(北京)科技有限责任公司
      <a style="text-decoration:none;" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">{{ icpCode }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "footers",
  data() {
    return {
      icpCode: '京ICP备2020036021号'
    }
  },
  mounted() {
    let host = window.location.host;
    console.log(window.location.host);
    if (host.indexOf('sfdy.com') != -1) {
      this.icpCode = '京ICP备2020036021号-3'
    } else if (host.indexOf('sfdy.cn') != -1) {
      this.icpCode = '京ICP备2020036021号-4'
    } else {
      this.icpCode = '京ICP备2020036021号'
    }
  }
}
</script>

<style lang="less">
.footers {
  width: 100%;
  box-sizing: border-box;

  .contain {
    color: #ffffff;
    border-bottom: 1px solid #ffffff;
    padding-top: 0.84rem;
    width: 13.00rem;
    padding-bottom: 0.60rem;
    box-sizing: border-box;

    .logo {
      width: 1.92rem;
      margin-top: 0.40rem;
    }

    .image0 {
      float: left;
      width: 1.19rem;
      height: 1.20rem;
    }

    .image1 {
      float: left;
      width: 1.19rem;
      height: 1.20rem;
    }

    .image2 {
      float: left;
      margin-top: 0.07rem;
      margin-right: 0.1rem;
      width: 0.34rem;
      height: 0.27rem;
    }

    .menu-col {
      box-sizing: border-box;
    }

    .link-tab {
      display: block;
      cursor: pointer;
      color: #ffffff;
      text-align: left;
      line-height: 0.40rem;
      font-size: 0.16rem;
      box-sizing: border-box;
      padding: 0;
      margin: 0;
    }

    .short-menu {
      padding-right: 0.48rem;
      // 备选：占位符方式
      // &::after {
      //   content: "　　";
      //   visibility: hidden;
      // }
    }

    .introduce {
      float: left;
      width: 100%;
      text-align: left;
      font-size: 0.14rem;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 0.42rem;
      box-sizing: border-box;
      &:first-of-type {
        margin-top: 0.07rem;
      }
    }

    .code-title {
      float: left;
      width: 1.19rem;
      font-size: 0.14rem;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 0.20rem;
      text-align: center;
      margin-top: 0.14rem;
      box-sizing: border-box;
    }
  }

  // 整体row设置flex，其余col靠下，第一个col单独靠上
  .footer-row {
    display: flex;
    align-items: flex-end; // 默认所有col靠下
    justify-content: space-between;
    // 第一个col靠上对齐
    .col-top {
      align-self: flex-start; // 覆盖父级的flex-end，垂直靠上
    }
  }

  .icp-content {
    padding: 0.28rem 0;
    font-size: 0.16rem;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.22rem;
    text-align: center;
    box-sizing: border-box;

    a {
      color: #ffffff;
      margin-left: 0.05rem;
    }
  }
}
</style>